module.exports = __webpack_public_path__ + "static/img/exploit17.f4034566.png";